import { render, staticRenderFns } from "./articulos-detalles-ofertas.vue?vue&type=template&id=b0aaadc6&scoped=true&"
import script from "./articulos-detalles-ofertas.vue?vue&type=script&lang=ts&"
export * from "./articulos-detalles-ofertas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aaadc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VList,VListItem,VProgressCircular})
